export default "__VITE_ASSET__BVdlEpvz__"